import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';
import { instellingenPaginaLink } from '@menu-lib/urlHelper';

MenuItemRegistry.register(MenuItems.Instellingen, {
  isVisible: () => true,
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;
    const heeftSpfMeldingen = settings.isInstellingsRechten && !!tellingen.spfMeldingen;

    const link = instellingenPaginaLink(settings.isInstellingsRechten);

    return {
      itemtype: 'link',
      menuItem: MenuItems.Instellingen,
      title: 'Instellingen',
      url: link,
      iconclass: 'far fa-cog',
      showbadge: heeftSpfMeldingen,
      badgecontent: heeftSpfMeldingen ? '1' : undefined,
      target: '_top',
    };
  },
});
